{
  "languages": {
    "select": "Seleccionar idioma",
    "english": "En",
    "french": "FR",
    "german": "DE",
    "spanish": "ES",
    "portuguese": "PT"
  },
  "nav": {
    "dashboard": "Panel",
    "clients": "Clientes",
    "myBookings": "Mis Reservas",
    "loginTrainer": "Inicio de sesión del entrenador",
    "login": "Iniciar sesión",
    "logout": "Cerrar sesión",
    "accountSettings": "Configuración de la cuenta",
    "changePassword": "Cambiar contraseña",
    "home": "Inicio",
    "pricing": "Precios",
    "contact": "Contacto",
    "affiliate": "Programa de afiliados",
    "yogaStudioSoftware": "Software para estudios de yoga",
    "pilatesStudioSoftware": "Software para estudios de pilates",
    "cantienicaStudioSoftware": "Software para estudios CANTIENICA",
    "resources": "Recursos",
    "guides": "Guías",
    "blog": "Blog"
  },
  "accountSettings": {
    "title": "Configuración de la cuenta",
    "editTitle": "Editar perfil",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "updateSuccess": "Perfil actualizado",
    "updateSuccessMessage": "Tu perfil ha sido actualizado con éxito",
    "firstNameRequired": "El nombre es obligatorio",
    "lastNameRequired": "El apellido es obligatorio",
    "dangerZone": "Zona de peligro",
    "deleteAccount": "Eliminar mi cuenta",
    "deleteWarning": "Esto eliminará permanentemente tu cuenta y todos los datos asociados. Esta acción no se puede deshacer.",
    "confirmDelete": "¿Estás seguro de que deseas eliminar tu cuenta?",
    "deleteSuccess": "Cuenta eliminada",
    "deleteSuccessMessage": "Tu cuenta ha sido eliminada exitosamente.",
    "deleteDialog": {
      "title": "Eliminar mi cuenta",
      "description": "¿Estás seguro de que deseas eliminar tu cuenta y todos los datos asociados? Esta acción no se puede deshacer."
    }
  },
  "password": {
    "changeTitle": "Cambiar contraseña",
    "current": "Contraseña actual",
    "new": "Nueva contraseña",
    "confirm": "Confirmar nueva contraseña",
    "error": "Error",
    "mismatch": "Las nuevas contraseñas no coinciden",
    "updateSuccess": "Contraseña actualizada",
    "updateSuccessMessage": "Tu contraseña ha sido actualizada con éxito",
    "currentPasswordRequired": "Se requiere la contraseña actual",
    "newPasswordRequired": "Se requiere la nueva contraseña",
    "confirmPasswordRequired": "Se requiere la confirmación de la contraseña",
    "passwordsDoNotMatch": "Las contraseñas no coinciden"
  },
  "classes": {
    "title": "Clases disponibles",
    "bookIntro": "Reserva tu próxima sesión con nuestros entrenadores expertos",
    "bookNow": "Reservar ahora",
    "online": "En línea",
    "spots": "Lugares disponibles",
    "noClassesAvailableClearFilter": "No hay clases disponibles. Intente con otra fecha o borre el filtro para ver todas las clases disponibles.",
    "noClassesAvailable": "No hay clases disponibles.",
    "confirmBookingTitle": "¡Clase Reservada!",
    "confirmBookingDescription": "Has reservado con éxito la clase {title} con {trainer} el {date} a las {time}."
  },
  "classForm": {
    "title": "Título",
    "datetime": "Fecha/Hora",
    "duration": "Duración",
    "capacity": "Capacidad",
    "price": "Precio",
    "currency": "Divisa",
    "status": "Estado",
    "statusOptions": {
      "available": "Disponible",
      "canceled": "Cancelado",
      "hidden": "Oculto"
    },
    "location": "Ubicación",
    "locationOptions": {
      "studio": "Estudio",
      "online": "En línea"
    },
    "trainer": "Entrenador",
    "isRecurring": "Clase recurrente",
    "submit": "Enviar",
    "repeatEvery": "Repite cada",
    "repeatPeriod": "Período",
    "repeatPeriodOptions": {
      "week": "Semana",
      "month": "Mes",
      "year": "Año"
    },
    "maxEvents": "Número máximo de eventos",
    "validation": {
      "titleRequired": "El título debe tener al menos 2 caracteres.",
      "minCapacity": "La capacidad debe ser al menos 1.",
      "maxEvents": "El número máximo de eventos debe estar entre 1 y 24."
    },
    "cancelClass": "Cancelar clase",
    "deleteClass": "Eliminar clase",
    "cancelDialog": {
      "title": "Cancelar clase",
      "description": "¿Está seguro de que desea cancelar esta clase? Esta acción no se puede deshacer."
    },
    "deleteDialog": {
      "title": "Eliminar clase",
      "description": "¿Está seguro de que desea eliminar esta clase? Esta acción no se puede deshacer."
    },
    "cancelSuccess": {
      "title": "Clase cancelada",
      "description": "La clase ha sido cancelada con éxito."
    },
    "deleteSuccess": {
      "title": "Clase eliminada",
      "description": "La clase ha sido eliminada con éxito."
    },
    "createSuccess": {
      "title": "Clase creada",
      "description": "La clase se ha creado con éxito."
    }
  },
  "classCard": {
    "editClass": "Editar clase",
    "enrolled": "inscrito",
    "status": "Estado",
    "at": "a",
    "min": "Min.",
    "spots": "espacios",
    "location": "Ubicación",
    "trainer": "Entrenador",
    "enrolledClients": "Clientes inscritos",
    "noEnrolledClients": "No hay clientes inscritos.",
    "confirmRemoval": "Confirmar eliminación",
    "confirmRemovalDescription": "¿Está seguro de que desea eliminar a {{name}} de la clase?",
    "clientHistory": "Historial de reservas de {{name}}",
    "lastBookings": "A continuación se muestra el historial de las últimas 10 reservas realizadas por este cliente.",
    "bookNow": "Reservar ahora",
    "booked": "Reservado",
    "classFullyBooked": "Completo"
  },
  "bookingSummary": {
    "title": "Resumen de la reserva",
    "description": "Por favor revise los detalles de su reserva de clase",
    "min": "Min.",
    "cancellationPolicy": "Puede cancelar su reserva hasta 24 horas antes del inicio de la clase sin costo. Para cancelaciones realizadas menos de 24 horas antes de la hora de inicio, se cobrará el monto completo.",
    "agreeText": "Al continuar, usted acepta nuestros",
    "terms": "Términos",
    "and": "y",
    "privacyPolicy": "Política de privacidad",
    "confirmBooking": "Confirmar reserva",
    "sessions": "Número de sesiones",
    "selectSessions": "Seleccione el número de sesiones",
    "sessionsDescription": "Seleccione cuántas sesiones desea reservar.",
    "bookingFailedTitle": "Error en la reserva",
    "bookingFailedDescription": "No se pudo reservar la clase. Inténtalo de nuevo más tarde.",
    "bookingFullDescription": "Esta clase está llena. Por favor, elija otra sesión o fecha."
  },
  "login": {
    "title": "Iniciar sesión",
    "description": "Ingrese sus credenciales para acceder a su cuenta",
    "email": "Correo electrónico",
    "emailPlaceholder": "Ingrese su correo electrónico",
    "password": "Contraseña",
    "signIn": "Iniciar sesión",
    "forgotPassword": "¿Olvidaste la contraseña?"
  },
  "terms": {
    "title": "Términos y Condiciones",
    "scope": {
      "title": "1. Alcance",
      "description": "Estos Términos y Condiciones (\"Términos\") se aplican al uso de nuestra plataforma de reservas de estudios de fitness (\"App\"), que permite a los estudios de fitness publicar sus clases y a los usuarios reservarlas. Al registrarse y usar la App, usted acepta estar sujeto a estos Términos."
    },
    "services": {
      "title": "2. Servicios Ofrecidos",
      "description": "Nuestra App permite a los usuarios:",
      "features": {
        "browse": "Explorar y reservar clases de fitness ofrecidas por estudios participantes.",
        "manage": "Gestionar sus reservas a través de su cuenta de usuario."
      },
      "disclaimer": "Actuamos únicamente como proveedores de la plataforma y no somos responsables de la calidad, disponibilidad o ejecución de las clases de fitness ofrecidas por terceros."
    },
    "registration": {
      "title": "3. Registro y Cuentas de Usuario",
      "points": {
        "accurateInfo": "Los usuarios deben proporcionar información precisa y actualizada durante el registro.",
        "confidentiality": "Cada usuario es responsable de mantener la confidencialidad de sus credenciales de cuenta.",
        "payment": "Esta aplicación es completamente gratuita para los usuarios. No cobramos ninguna tarifa por la reserva de clases, y los usuarios nunca serán solicitados a realizar pagos a través de la aplicación."
      }
    },
    "booking": {
      "title": "4. Reservas y Cancelaciones",
      "points": {
        "binding": "Las reservas son vinculantes una vez confirmadas.",
        "cancellationPolicy": "Cada estudio de fitness establece su propia política de cancelación, a la que los usuarios deben adherirse.",
        "refunds": "No somos responsables de reembolsos o cancelaciones; estos son gestionados por los respectivos estudios de fitness."
      }
    },
    "responsibilities": {
      "title": "5. Responsabilidades del Usuario",
      "points": {
        "lawfulUse": "Los usuarios aceptan usar la App de manera legal y no para actividades fraudulentas.",
        "studioRules": "Los usuarios deben seguir las reglas y políticas de los estudios de fitness con los que reservan."
      }
    },
    "liability": {
      "title": "6. Responsabilidad",
      "points": {
        "injuries": "No somos responsables de lesiones, daños o pérdidas que ocurran durante o como resultado de la participación en las clases reservadas.",
        "technicalMalfunctions": "Nuestra responsabilidad por daños debido a fallos técnicos de la App se limita a casos de negligencia grave o intención."
      }
    },
    "dataProtection": {
      "title": "7. Protección de Datos",
      "points": {
        "gdpr": "Los datos del usuario se procesan de acuerdo con nuestra Política de Privacidad y el GDPR."
      }
    },
    "termination": {
      "title": "8. Terminación y Suspensión de Cuenta",
      "points": {
        "suspension": "Nos reservamos el derecho de suspender o terminar cuentas que violen estos Términos."
      }
    },
    "governingLaw": {
      "title": "9. Ley Aplicable y Resolución de Disputas",
      "points": {
        "germanLaw": "Estos Términos se rigen por la ley alemana.",
        "disputeResolution": "Cualquier disputa se resolverá en los tribunales alemanes."
      }
    }
  },
  "privacy": {
    "title": "Política de Privacidad",
    "introduction": {
      "title": "1. Introducción",
      "description": "Esta Política de Privacidad explica cómo recopilamos, utilizamos y protegemos sus datos personales al usar nuestra aplicación de acuerdo con el Reglamento General de Protección de Datos (RGPD) y las leyes alemanas de protección de datos."
    },
    "dataController": {
      "title": "2. Responsable del Tratamiento de Datos",
      "description": "PraxiPro es el responsable del tratamiento de sus datos personales."
    },
    "dataCollected": {
      "title": "3. Datos Recopilados",
      "description": "Recopilamos los siguientes datos:",
      "points": {
        "account": "Solo se requieren el nombre y el correo electrónico para la creación de la cuenta.",
        "booking": "Historial de reservas y preferencias."
      }
    },
    "purpose": {
      "title": "4. Propósito del Tratamiento de Datos",
      "description": "Sus datos se procesan para los siguientes propósitos:",
      "points": {
        "account": "Proporcionar y gestionar su cuenta.",
        "booking": "Facilitar la reserva de clases.",
        "compliance": "Garantizar el cumplimiento de nuestros Términos y mejorar nuestros servicios."
      }
    },
    "dataSharing": {
      "title": "5. Compartir Datos",
      "points": {
        "fitnessStudios": "Sus datos solo se comparten con los estudios de fitness para facilitar su reserva."
      }
    },
    "dataSecurity": {
      "title": "6. Seguridad de los Datos",
      "description": "Implementamos medidas técnicas y organizativas para proteger sus datos contra el acceso no autorizado y el uso indebido."
    },
    "dataRetention": {
      "title": "7. Conservación de Datos",
      "points": {
        "retention": "Conservamos sus datos mientras sean necesarios para la prestación de nuestros servicios o según lo exija la ley.",
        "deletion": "Si decide eliminar su cuenta, la aplicación eliminará permanentemente todos los datos asociados con su cuenta. No se conservará ninguna información personal o datos relacionados, y su información se eliminará completamente de nuestro sistema."
      }
    },
    "userRights": {
      "title": "8. Sus Derechos",
      "description": "Como usuario, tiene los siguientes derechos bajo el RGPD:",
      "points": {
        "access": "Derecho a acceder, corregir o eliminar sus datos personales.",
        "object": "Derecho a oponerse al tratamiento de datos.",
        "portability": "Derecho a la portabilidad de los datos."
      }
    },
    "contact": {
      "title": "9. Información de Contacto",
      "description": "Para cualquier consulta relacionada con la privacidad, contáctenos en [hello@praxipro.de]."
    },
    "changes": {
      "title": "10. Cambios en Esta Política",
      "description": "Podemos actualizar esta Política de Privacidad periódicamente. Se informará a los usuarios sobre cambios significativos."
    },
    "consent": {
      "description": "Al usar nuestra aplicación, usted acepta los términos descritos en esta Política de Privacidad."
    }
  },
  "clientDashboard": {
    "title": "Mis Reservas",
    "bookedClasses": "Mis clases reservadas",
    "cancelSuccess": {
      "title": "Reserva cancelada",
      "description": "Su reserva de clase ha sido cancelada exitosamente"
    },
    "cancelDialog": {
      "title": "Cancelar reserva",
      "description": "¿Está seguro de que desea cancelar esta reserva? Esta acción no se puede deshacer."
    },
    "cannotCancel": "No se puede cancelar dentro de 24h"
  },
  "dashboard": {
    "createNewClass": "Crear nueva clase",
    "upcomingClasses": "Próximas clases",
    "historicalClasses": "Clases históricas",
    "createClass": {
      "title": "Crear nueva clase",
      "description": "Rellene los detalles de su nueva clase.",
      "create": "Crear clase"
    },
    "editClass": {
      "title": "Editar clase",
      "description": "Actualice los detalles de su clase.",
      "update": "Actualizar clase"
    },
    "stats": {
      "totalClasses": "Total de clases",
      "totalStudents": "Total de estudiantes"
    }
  },
  "forgotPassword": {
    "title": "Restablecer contraseña",
    "description": "Ingrese su dirección de correo electrónico y le enviaremos un enlace para restablecer su contraseña.",
    "emailLabel": "Correo electrónico",
    "emailPlaceholder": "Ingrese su correo electrónico",
    "sendResetLinkButton": "Enviar enlace de restablecimiento",
    "sendingButton": "Enviando...",
    "backToLoginButton": "Volver al inicio de sesión",
    "rememberPassword": "¿Recuerda su contraseña?",
    "toastSuccessTitle": "Enlace de restablecimiento enviado",
    "toastSuccessDescription": "Si existe una cuenta con este correo electrónico, recibirá un enlace para restablecer su contraseña.",
    "toastErrorTitle": "Error al restablecer la contraseña",
    "toastErrorDescription": "Hubo un problema al restablecer su contraseña. Por favor, inténtelo de nuevo más tarde."
  },
  "resetPassword": {
    "title": "Restablecer la contraseña",
    "description": "Ingrese su nueva contraseña para completar el restablecimiento.",
    "confirmRegistrationTitle": "Elige una contraseña",
    "confirmRegistrationDescription": "Introduce tu nueva contraseña para completar el proceso de registro.",
    "newPasswordLabel": "Nueva contraseña",
    "confirmPasswordLabel": "Confirmar contraseña",
    "sendResetLinkButton": "Enviar restablecimiento",
    "sendingButton": "Enviando...",
    "toastPasswordMismatchTitle": "Las contraseñas no coinciden",
    "toastPasswordMismatchDescription": "Asegúrese de que ambas contraseñas sean iguales.",
    "toastSuccessTitle": "Restablecimiento de contraseña exitoso",
    "toastSuccessDescription": "Su contraseña se ha restablecido con éxito.",
    "toastErrorTitle": "Error al restablecer la contraseña",
    "toastErrorDescription": "Hubo un problema al restablecer su contraseña. Intente nuevamente más tarde."
  },
  "authDialog": {
    "loginTitle": "Iniciar sesión para reservar clase",
    "signUpTitle": "Registrarse para reservar clase",
    "loginDescription": "Por favor, inicie sesión para confirmar su reserva",
    "signUpDescription": "Cree una cuenta para reservar clases",
    "firstName": "Nombre",
    "firstNamePlaceholder": "John",
    "lastName": "Apellido",
    "lastNamePlaceholder": "Doe",
    "email": "Correo electrónico",
    "emailPlaceholder": "john@example.com",
    "password": "Contraseña",
    "forgotPassword": "¿Olvidaste la contraseña?",
    "loginButton": "Iniciar sesión & Reservar",
    "signUpButton": "Registrarse & Reservar",
    "switchToSignUp": "¿No tienes cuenta? Regístrate",
    "switchToLogin": "¿Ya tienes cuenta? Inicia sesión",
    "loginFailed": "Error de inicio de sesión. Por favor, inténtelo de nuevo.",
    "emailAlreadyExists": "Este correo electrónico ya está registrado. Por favor, inicia sesión en su lugar. Si olvidaste tu contraseña, utiliza la opción « Olvidé mi contraseña ».",
    "registrationFailed": "Error de registro. Por favor, inténtelo de nuevo.",
    "registrationSuccessful": "¡Registro exitoso! Por favor, revise su correo electrónico para confirmar su dirección de correo electrónico."
  },
  "common": {
    "class": "Clase",
    "date": "Fecha",
    "time": "Hora",
    "duration": "Duración",
    "trainer": "Entrenador",
    "price": "Precio",
    "location": "Ubicación",
    "status": "Estado",
    "actions": "Acciones",
    "minutes": "minutos",
    "completed": "Completado",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "close": "Cerrar",
    "booked": "Reservado",
    "canceled": "Cancelado",
    "keepBooking": "Mantener reserva",
    "confirmCancel": "Sí, cancelar",
    "backToClasses": "Volver a las clases",
    "logout": "Cerrar sesión",
    "pickMonth": "Elige un mes",
    "pickDate": "Elige una fecha",
    "clear": "Borrar",
    "remove": "Eliminar",
    "submit": "Enviar",
    "pleaseWait": "Por favor, espera..."
  },
  "contactUs": {
    "title": "¿Necesitas ayuda? Contacta con nuestros expertos en software de reservas",
    "getInTouch": "Ponte en contacto para registrar tu estudio y comenzar tu prueba gratuita",
    "subHeading": "¡Nos encantaría saber de ti! Ya sea una pregunta sobre funciones, precios u otra cosa, nuestro equipo está listo para responder.",
    "fillOutContactForm": "Rellena el formulario y nos pondremos en contacto contigo lo antes posible.",
    "name": "Nombre",
    "enterName": "Introduce tu nombre",
    "email": "Correo electrónico",
    "enterEmail": "Introduce tu correo electrónico",
    "studioName": "Nombre del estudio",
    "enterStudioName": "Introduce el nombre del estudio",
    "message": "Mensaje",
    "enterMessage": "Introduce tu mensaje",
    "sendMessage": "Enviar mensaje",
    "sendingMessage": "Enviando mensaje",
    "submit": "Enviar",
    "nameMin": "El nombre debe tener al menos 2 caracteres.",
    "emailInvalid": "Por favor, introduce una dirección de correo válida.",
    "messageMin": "El mensaje debe tener al menos 10 caracteres.",
    "requestSent": "Solicitud enviada",
    "weWillGetBack": "¡Nos pondremos en contacto contigo en breve!",
    "toastErrorTitle": "Ocurrió un error",
    "toastErrorDescription": "Se produjo un error al procesar tu solicitud. Por favor, intenta más tarde.",
    "alertStudioProfessional": "Este formulario está destinado a profesionales que desean registrar su estudio.",
    "needSupport": {
      "title": "¿Necesitas ayuda?",
      "description": "Obtén respuestas al instante."
    },
    "feedback": {
      "title": "¿Tienes comentarios?",
      "description": "Cuéntanos aquí."
    },
    "reportIssue": {
      "title": "Informar de un problema",
      "description": "Obtén soporte prioritario."
    },
    "community": {
      "title": "Comunidad",
      "description": "Conéctate con otros usuarios."
    }
  },
  "landing": {
    "title": "Software de gestión de estudios para gimnasios",
    "heroTitle": "Aplicación moderna para estudios de Yoga, Pilates, Fisioterapia y CANTIENICA",
    "heroDescription": "La plataforma todo-en-uno para propietarios de estudios de fitness para gestionar clases, clientes y hacer crecer su negocio de manera eficiente.",
    "ctaText": "Comienza la Prueba Gratuita",
    "featuresSectionTitle": "Todo lo que necesitas para administrar tu estudio",
    "featuresSectionDescription": "Herramientas poderosas diseñadas específicamente para propietarios de estudios de fitness",
    "classManagementTitle": "Gestión de Clases",
    "classManagementDescription": "Gestiona fácilmente tu horario de clases, maneja las reservas y realiza un seguimiento de la asistencia en tiempo real",
    "clientManagementTitle": "Gestión de Clientes",
    "clientManagementDescription": "Haz un seguimiento de tus clientes, su historial de reservas y gestiona las membresías todo en un solo lugar",
    "businessAnalyticsTitle": "Análisis de Negocios",
    "businessAnalyticsDescription": "Obtén información sobre el rendimiento de tu estudio con informes y análisis detallados",
    "benefitsSectionTitle": "Haz Crecer tu Negocio con Herramientas Inteligentes",
    "benefitsSectionDescription": "Herramientas inteligentes para ayudar a crecer tu negocio.",
    "benefit1": "Reduce las ausencias con recordatorios automatizados",
    "benefit2": "Aumenta los ingresos con opciones de precios flexibles",
    "benefit3": "Ahorra tiempo con programación automatizada",
    "benefit4": "Mejora la retención de clientes con herramientas de compromiso",
    "benefit5": "Toma decisiones basadas en datos con análisis detallados",
    "benefit6": "Optimiza las operaciones con herramientas integradas",
    "ctaSectionTitle": "¿Listo para Transformar la Gestión de tu Estudio?",
    "ctaSectionDescription": "Únete a los propietarios de estudios exitosos que han optimizado sus operaciones con nuestra plataforma.",
    "featuredStudiosTitle": "Estudios destacados que usan FitCalendar",
    "featuredStudiosIntro": "Únete a estos negocios de fitness exitosos que han transformado su operación con nuestra plataforma",
    "physiotherapyPractice": "Clínica de fisioterapia",
    "onlineBooking": "Reserva en línea",
    "howFitCalendarWorksTitle": "Cómo funciona FitCalendar",
    "howFitCalendarWorksIntro": "Empieza fácilmente con nuestro proceso de cuatro pasos",
    "howFitCalendarWorksStep1Title": "Regístrate",
    "howFitCalendarWorksStep1Intro": "Crea tu cuenta y configura tu perfil en minutos",
    "howFitCalendarWorksStep2Title": "Crea",
    "howFitCalendarWorksStep2Intro": "Agrega tus clases y prepara tu estudio para recibir reservas",
    "howFitCalendarWorksStep3Title": "Integra",
    "howFitCalendarWorksStep3Intro": "Conecta tus herramientas existentes y añade el enlace de reservas a tu sitio web",
    "howFitCalendarWorksStep4Title": "Crece",
    "howFitCalendarWorksStep4Intro": "Enfócate en tus clientes mientras nosotros nos encargamos de la administración",
    "viewPricing": "Ver precios",
    "rating": "Valoración",
    "happyUsers": "Usuarios satisfechos",
    "freeTrial": "Prueba gratuita",
    "realTimeDashboard": "Panel del estudio en tiempo real",
    "trackYourStudioPerformance": "Supervisa el rendimiento de tu estudio"
  },
  "pricing": {
    "title": "Precios",
    "header": "Planes asequibles de software de reservas para fitness",
    "subHeader": "Una suscripción asequible para todo lo que tu centro necesita — planificación de clases, reservas de clientes y gestión del estudio sin complicaciones.",
    "freeTrial": "Prueba gratuita",
    "freeTrialDesc": "Para estudios que prueban la plataforma",
    "freeTrialFeatures": [
      "Acceso completo por 14 días",
      "Gestión básica del calendario",
      "Hasta 5 clases por semana",
      "Perfiles básicos de clientes"
    ],
    "startFreeTrial": "Comenzar prueba gratuita",
    "standard": "Estándar",
    "standardDesc": "Por estudio, facturado mensualmente",
    "standardFeatures": [
      "Clases y citas ilimitadas",
      "Gestión avanzada del calendario",
      "Reservas en línea para clientes",
      "Sistema completo de gestión de clientes",
      "Integración de pagos",
      "Informes y análisis básicos",
      "Soporte por correo electrónico"
    ],
    "subscribeNow": "Suscribirse ahora",
    "annual": "Anual",
    "annualDesc": "Ahorra un 20 % con la facturación anual",
    "annualFeatures": [
      "Todas las funciones Estándar",
      "2 meses gratis (equivalente a 16 €/mes)",
      "Soporte prioritario al cliente",
      "Informes y análisis avanzados"
    ],
    "subscribeAnnually": "Suscribirse anualmente",
    "popularPlan": "Más popular",
    "perMonth": "/mes",
    "perYear": "/año",
    "faqsTitle": "Preguntas frecuentes",
    "faqsQ1": "¿Puedo cambiar mi plan?",
    "faqsA1": "Sí, puedes cambiar a un plan anual en cualquier momento. El cambio a mensual estará disponible cuando finalice la suscripción anual.",
    "faqsQ2": "¿Ofrecen descuentos para varios estudios?",
    "faqsA2": "¡Sí! Para estudios con varias sedes ofrecemos descuentos por volumen. Contacta a nuestro equipo de ventas para precios personalizados.",
    "faqsQ3": "¿Qué métodos de pago aceptan?",
    "faqsA3": "Aceptamos todas las principales tarjetas de crédito y PayPal. Para planes anuales también aceptamos transferencias bancarias.",
    "faqsQ4": "¿Hay una tarifa de instalación?",
    "faqsA4": "No, no hay tarifas ocultas. Tu suscripción cubre todo: instalación, alojamiento y actualizaciones periódicas."
  },
  "affiliate": {
    "title": "Programa de afiliados",
    "heading": "💼 Únete a nuestro programa de afiliados",
    "description": "Gana dinero recomendando instructores de Yoga, Pilates, Fitness, fisioterapeutas, profesionales de CANTIENICA y coaches de movimiento a FitCalendar. Es fácil, gratificante y crece contigo.",
    "rewardOne": {
      "amount": "💶 96 €",
      "text": "por cada nuevo usuario que se suscriba durante un año completo."
    },
    "rewardTwo": {
      "amount": "📅 8 €/mes",
      "text": "por usuario durante un año si elige el pago mensual."
    },
    "rewardThree": {
      "title": "🏆 Bono de por vida:",
      "description": "Recomienda a más de 50 usuarios de pago y recibe",
      "amount": "3 €/mes",
      "forever": "para siempre"
    },
    "ctaHeading": "🎉 Comienza hoy mismo",
    "ctaDescription": "Rellena el siguiente formulario y recibe tu código de referencia por correo electrónico. ¡Compártelo y empieza a ganar!",
    "form": {
      "firstName": "Nombre",
      "lastName": "Apellido",
      "email": "Correo electrónico",
      "submit": "Obtener mi código de referencia",
      "loading": "Registrando..."
    },
    "firstNameMin": "El nombre es obligatorio",
    "lastNameMin": "El apellido es obligatorio",
    "emailInvalid": "Dirección de correo electrónico no válida"
  },
  "register": {
    "title": "Registro del estudio",
    "description": "Registra tu estudio y comienza tu prueba gratuita",
    "name": "Nombre",
    "enterName": "Ingresa tu nombre",
    "email": "Correo electrónico",
    "enterEmail": "Ingresa tu correo electrónico",
    "studioName": "Nombre del estudio",
    "enterStudioName": "Ingresa el nombre del estudio",
    "message": "Mensaje",
    "enterMessage": "Ingresa tu mensaje",
    "sendMessage": "Enviar mensaje",
    "sendingMessage": "Enviando mensaje",
    "submit": "Enviar",
    "submitting": "Enviando...",
    "nameMin": "El nombre debe tener al menos 2 caracteres.",
    "emailInvalid": "Por favor ingresa un correo electrónico válido.",
    "messageMin": "El mensaje debe tener al menos 10 caracteres.",
    "requestSent": "Solicitud enviada",
    "weWillGetBack": "¡Nos pondremos en contacto contigo pronto!",
    "toastErrorTitle": "Ocurrió un error",
    "toastErrorDescription": "Ocurrió un error al procesar tu solicitud. Por favor intenta más tarde.",
    "alertStudioProfessional": "Este formulario está destinado a profesionales que desean registrar su estudio."
  },
  "guides": {
    "title": "Biblioteca de recursos"
  },
  "blog": {
    "title": "Consejos de Yoga, Pilates, CANTIENICA y Fitness"
  },
  "clients": {
    "title": "Lista de clientes",
    "description": "Administre sus clientes de fitness y vea su historial de reservas.",
    "listTitle": "Base de datos de clientes",
    "searchPlaceholder": "Buscar por nombre o correo electrónico...",
    "searchButton": "Buscar",
    "searching": "Buscando...",
    "table.name": "Nombre",
    "table.email": "Correo electrónico",
    "table.totalBookings": "Total de reservas",
    "table.actions": "Acciones",
    "table.class": "Clase",
    "table.date": "Fecha",
    "table.time": "Hora",
    "table.duration": "Duración",
    "table.price": "Precio",
    "table.status": "Estado",
    "viewClasses": "Ver reservas",
    "loading": "Cargando...",
    "noClientsFound": "No se encontraron clientes.",
    "searchError.apiTitle": "Error de API",
    "searchError.apiDescription": "No se pudieron cargar los datos del servidor.",
    "searchError.title": "Advertencia de búsqueda",
    "minLengthWarning": "Por favor, ingrese al menos 3 caracteres para buscar.",
    "bookingsTitle": "Reservas de {{name}}",
    "noBookings": "No hay datos de reservas disponibles.",
    "bookingsDescription": "A continuación se muestra el historial de todas las reservas realizadas por este cliente.",
    "status.booked": "Reservado",
    "status.canceled": "Cancelado"
  }
}